var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 107,
    viewBox: "0 0 120 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_6155)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2209 74.3678C24.5538 75.5532 21.788 79.6889 20.7385 81.6086C18.8067 86.3465 19.0616 96.5132 35.5349 99.2771C52.0083 102.041 58.4607 93.9747 58.4607 93.9747C58.4607 93.9747 67.8157 102.728 79.5689 104.036C91.322 105.343 105.806 105.219 109.554 91.0156C111.166 84.909 108.393 78.1693 102.592 74.3678C113.163 73.5312 124.486 66.5165 118.19 50.9701C113.402 39.1452 93.0533 34.8569 83.6431 35.1147C84.1587 31.1332 80.2142 20.9442 60.3109 12.0405C35.4319 0.91081 13.3459 3.98098 8.37523 22.9865C4.54902 37.6161 11.7971 47.9031 14.6887 52.0069L14.719 52.05C10.737 66.5891 20.7385 72.238 27.2209 74.3678Z",
    fill: "#F1F4F7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.153 41.8679L1.04454 54.8926C0.353911 50.3538 0.41534 39.9758 10.6773 35.7329C18.8868 32.3386 26.9296 38.4144 30.153 41.8679Z",
    fill: "#CEDAEE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter0_f_1050_6155)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.065 67.641C24.7984 59.3568 21.8054 54.5306 20.2601 52.0875C20.2601 51.2791 24.983 51.3868 25.3603 52.0875C25.7375 52.7881 32.2586 57.7461 34.3065 66.0456C36.3545 74.3451 78.4514 87.9583 74.3818 89.9618C69.9628 92.1373 63.0985 94.1857 53.405 91.0441C43.4184 87.8075 34.3876 77.9754 29.065 67.641Z",
    fill: "#BAC9E3",
    fillOpacity: 0.2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65241 59.3492C7.16365 50.4195 11.01 47.7019 13.1817 46.6504C20.4923 44.968 24.6409 49.9397 25.8014 52.6359C22.1346 54.0379 13.5714 57.3433 8.65241 59.3492Z",
    fill: "#BAC9E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2161 64.5751C22.1244 49.8286 16.4053 46.197 13.2091 46.6671L49.5987 29.3542C53.5271 29.878 62.7194 34.0739 68.0619 46.6671C73.4045 59.2603 92.704 67.3617 100.095 72.8959C93.1734 77.9985 78.8547 88.0607 73.772 90.2164C67.32 92.9529 58.0118 92.0329 51.5644 88.9039C45.117 85.775 36.396 79.5051 29.2161 64.5751Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1050_6155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 29,
    width: 88,
    height: 63
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2161 64.5751C22.1244 49.8286 16.4053 46.197 13.2092 46.6671L49.5987 29.3542C53.5271 29.878 62.7194 34.0739 68.0619 46.6671C73.4045 59.2603 92.704 67.3617 100.095 72.8959C93.1734 77.9985 78.8547 88.0607 73.772 90.2164C67.32 92.9529 58.0118 92.0329 51.5644 88.9039C45.117 85.775 36.396 79.5051 29.2161 64.5751Z",
    fill: "#EAEEF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1050_6155)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1050_6155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0639 55.0411C23.9775 41.1568 15.6444 39.2473 12.1137 40.0281L46.3177 26.7936C56.2084 26.4206 62.9404 28.8187 67.5951 35.6768C70.7154 40.2742 72.712 46.1273 78.3339 54.533C87.194 67.7807 95.6427 69.3531 100.558 69.1354L78.3339 84.6327C73.8929 87.7093 67.1294 87.8738 62.4978 87.0256C42.3073 83.328 35.4219 72.3965 29.0639 55.0411Z",
    fill: "#EAF1FA"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3986 50.2302C23.0503 36.4447 14.6826 34.6932 11.1672 35.5407L45.1146 21.6612C54.9964 21.101 61.7726 23.3712 66.5563 30.14C69.7631 34.6775 71.8702 40.4918 77.6501 48.7896C86.7594 61.8671 100.615 65.1349 105.524 64.8242L78.732 82.8217C73.5258 86.9373 65.5319 85.737 60.885 84.9766C39.6039 80.5509 35.084 67.4621 28.3986 50.2302Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9387 70.0938C79.2477 66.6097 85.2952 74.3282 81.2866 80.2945C80.8499 80.9444 79.3288 82.3455 78.7326 82.8168L105.525 64.8193C109.475 61.9293 112.488 58.2857 109.475 53.2385C106.461 48.1913 101.439 49.9427 99.3048 51.4494C92.4935 56.1889 77.6846 66.5532 72.9387 70.0938Z",
    fill: "#CEDAEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0511 64.1667C64.6955 62.8244 57.6406 50.8044 54.5326 44.9623C55.9621 44.1233 60.2381 41.7182 65.9061 38.8096C71.2013 48.7286 76.8756 55.6832 79.0509 57.9206C76.7202 59.2568 71.2574 62.3767 68.0511 64.1667Z",
    fill: "#F1F4F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8721 46.7339C48.4546 46.8086 41.1406 50.7424 37.6608 52.7C41.763 66.7955 49.6245 72.1218 53.0424 73.0231C55.1866 71.749 60.4258 68.6415 64.2294 66.4041C55.0934 58.9462 50.6186 48.3186 49.8721 46.7339Z",
    fill: "#F1F4F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1983 37.5043L44.1836 30.8854",
    stroke: "#F1F4F7",
    strokeWidth: 2.77925
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6295 42.7248L54.5771 32.8646",
    stroke: "#F1F4F7",
    strokeWidth: 2.77925
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.0508,
    cy: 26.814,
    rx: 18,
    ry: 17.9999,
    fill: "#AEBED6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6063 20.1022C76.6063 18.7544 77.6989 17.6619 79.0466 17.6619C80.3944 17.6619 81.487 18.7544 81.487 20.1022L80.5548 29.5059C80.5548 30.3388 79.8796 31.014 79.0466 31.014C78.2137 31.014 77.5385 30.3388 77.5385 29.5059L76.6063 20.1022ZM79.0471 36.4807C80.0273 36.4807 80.8219 35.6861 80.8219 34.7059C80.8219 33.7257 80.0273 32.9311 79.0471 32.9311C78.0669 32.9311 77.2723 33.7257 77.2723 34.7059C77.2723 35.6861 78.0669 36.4807 79.0471 36.4807Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9067 15.9256C27.3628 16.7924 27.2014 17.8553 27.2567 18.7449C27.2588 18.7825 27.2783 18.8038 27.3152 18.8088C28.0249 18.9139 29.778 18.8901 30.0673 19.5965C30.3566 20.3008 30.1963 21.1568 29.2872 21.2381C28.2087 21.3334 27.1963 21.1301 26.2501 20.6281C24.9216 19.9227 24.8566 18.3006 24.8913 17.0015C24.887 16.8137 24.8346 16.7198 24.7342 16.7198C23.9208 16.7176 23.2349 16.623 22.6766 16.4359C21.3449 15.9906 21.6689 14.2093 23.1067 14.284C24.6193 14.361 26.0485 14.4942 26.9067 15.9256Z",
    fill: "#D5E0EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.011 29.9863C111.035 29.941 111.046 29.8892 111.041 29.8378C111.035 29.7864 111.015 29.7377 110.982 29.6981L108.355 26.5645C108.346 26.5535 108.34 26.5401 108.338 26.5258C108.336 26.5116 108.338 26.4971 108.344 26.484C108.35 26.4709 108.36 26.4599 108.372 26.452C108.384 26.4442 108.398 26.44 108.413 26.4399C108.673 26.4377 108.936 26.4247 109.197 26.467C110.307 26.6454 111.411 26.7707 112.512 26.843C112.552 26.8459 112.592 26.8375 112.628 26.8187C112.664 26.8 112.694 26.7716 112.715 26.7368C113.364 25.6435 114.019 24.5242 114.718 23.4429C114.735 23.4164 114.759 23.3955 114.788 23.3827C114.817 23.3698 114.848 23.3656 114.88 23.3705C114.911 23.3755 114.94 23.3893 114.963 23.4105C114.986 23.4316 115.003 23.459 115.011 23.4895C115.347 24.7644 115.62 25.9996 115.829 27.1951C115.864 27.3934 115.96 27.4812 116.162 27.5267C117.012 27.7185 117.89 27.8366 118.704 28.0771C119.096 28.1941 119.496 28.314 119.903 28.4368C120.018 28.4715 120.029 28.5268 119.936 28.6026C119.785 28.7254 119.596 28.8511 119.369 28.9797C118.393 29.5344 117.418 30.0932 116.446 30.6559C116.414 30.6747 116.397 30.7025 116.396 30.7393C116.391 30.8744 116.394 31.0474 116.405 31.2583C116.465 32.4625 116.573 33.65 116.731 34.821C116.734 34.8412 116.731 34.8618 116.723 34.8806C116.715 34.8994 116.702 34.9156 116.685 34.9274C116.668 34.9393 116.649 34.9463 116.628 34.9478C116.608 34.9493 116.588 34.9451 116.569 34.9358C116.376 34.8376 116.194 34.7115 116.022 34.5577C115.169 33.797 114.28 32.8349 113.338 32.2053C113.309 32.1851 113.278 32.1847 113.247 32.2042C112.855 32.4502 112.405 32.5055 112.034 32.6918C111.215 33.1021 110.39 33.421 109.558 33.6486C109.529 33.6565 109.498 33.6557 109.469 33.6464C109.44 33.637 109.415 33.6195 109.396 33.596C109.377 33.5725 109.365 33.544 109.363 33.5141C109.36 33.4841 109.366 33.4541 109.38 33.4275C109.981 32.2877 110.414 31.0936 111.011 29.9863Z",
    fill: "#D5E0EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1189 82.9796C96.6888 82.8655 97.2548 82.743 97.8168 82.6123C98.5818 82.4346 99.0585 83.1389 98.9762 83.8518C98.896 84.5485 98.4669 84.6905 97.8027 84.8769C97.4083 84.9881 97.0298 85.1304 96.6672 85.3038C96.6444 85.3145 96.6257 85.3323 96.6136 85.3544C96.6016 85.3766 96.5968 85.4021 96.6 85.4273C96.7452 86.5747 96.9402 87.4654 96.1471 88.4677C95.3745 89.4439 93.9908 89.7852 92.8055 89.5447C92.2713 89.4374 92.1987 88.6887 92.2734 88.277C92.4555 87.2714 93.7904 87.6258 94.4297 87.0732C94.4512 87.0542 94.4676 87.0302 94.4773 87.0033C94.4869 86.9763 94.4896 86.9474 94.4849 86.9193C94.3127 85.8737 94.1848 84.5756 94.9519 83.7283C95.1616 83.4976 95.8148 83.0333 96.1189 82.9796Z",
    fill: "#D5E0EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1050_6155",
    x: 18.2601,
    y: 49.5209,
    width: 58.3986,
    height: 45.1354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1050_6155"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1050_6155",
    x: 7.11368,
    y: 21.7565,
    width: 98.4438,
    height: 70.7101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1050_6155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_6155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 106,
    fill: "white",
    transform: "translate(0 0.722534)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.86d9c51d3699168fc9dcda2791969c67.svg";
export { ForwardRef as ReactComponent };